import { ReactNode } from 'react';

interface CvSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export default function CvSection({ title, children, className = '' }: CvSectionProps) {
  return (
    <section className={`mb-16 print:mb-10 ${className}`}>
      <h2 className="text-2xl font-semibold text-white mb-4 pb-2 border-b border-[rgba(198,156,109,0.3)] print:text-black print:border-gray-300 print:mb-2 print:pb-1">
        {title}
      </h2>
      <div className="print:text-black">
        {children}
      </div>
    </section>
  );
} 